import type { VoxelRaster } from 'src/modules/Editor/models/raster/VoxelRaster'

import type { RasterBufferAccessor } from '@/modules/Editor/models/raster/RasterBufferAccessor'

import type { Plane } from './Plane'
import { MedicalVolumePlane } from '@/modules/Editor/MedicalMetadata'
import { primaryPlaneToRasterPlaneData } from '@/modules/Editor/utils/raster/primaryPlaneToRasterPlaneData'

const outOfBoundsErrorMessage = 'Requesting plane outside of volume range'

/**
 * Returns a RasterBufferAccessor for a given frame of a VoxelRaster,
 * allowing that frame to be renderered/edited.
 */
export const getRasterBufferAccessorForPlane = (
  raster: VoxelRaster,
  plane: Plane,
  frameIndex: number,
  acquiredPlane: MedicalVolumePlane = MedicalVolumePlane.AXIAL,
): RasterBufferAccessor => {
  const { voxelRasterBuffer, width, height, depth } = raster

  const {
    getIndex,
    width: accessorWidth,
    height: accessorHeight,
    depth: accessorDepth,
  } = primaryPlaneToRasterPlaneData(acquiredPlane, plane, width, height, depth)

  if (frameIndex < 0 || frameIndex >= accessorDepth) {
    throw new Error(outOfBoundsErrorMessage)
  }

  return {
    get(x: number, y: number): number {
      return voxelRasterBuffer[getIndex(x, y, frameIndex)]
    },
    set(x: number, y: number, val: number): void {
      voxelRasterBuffer[getIndex(x, y, frameIndex)] = val
    },
    width: accessorWidth,
    height: accessorHeight,
    plane,
  }
}
